import React from "react";
import { Button, Input } from "reactstrap";
import { getFormattedPrice } from "../../../services/helper";

const PaymentMethod = ({ method, index, amount, onChange, onPay, onKeyDown, canPay, remainingBalance, inputRef }) => (
  <div className="d-flex align-items-center mb-2 p-2 border rounded" style={{ backgroundColor: "#333" }}>
    <div className="flex-grow-1 me-2">
      <strong style={{ color: "white", fontSize: "13px" }}>{method.name}</strong>
    </div>
    <div className="me-2" style={{ width: "100px" }}>
      <Input
        type="number"
        placeholder="Amount"
        value={amount}
        onChange={onChange}
        onKeyDown={onKeyDown}
        step="0.01"
        min="0"
        size="sm"
        data-payment-index={index}
        style={{ fontSize: "12px" }}
        innerRef={inputRef}
      />
    </div>
    <Button
      color={method.color}
      onClick={onPay}
      disabled={!canPay}
      size="sm"
      style={{ fontSize: "11px", padding: "4px 12px" }}
    >
      Pay
    </Button>
  </div>
);

export default PaymentMethod;